import React, {ReactElement} from "react";

import {css} from "/src/utils/utils";

import * as styles from "./fast-fact-stacked.module.scss";

interface FastFactStackedProps {
  eyebrow?: string;
  headline?: string;
  trailing?: string;
  body?: string;
}

const FastFactStacked = (props: FastFactStackedProps): ReactElement | null => {
  const {eyebrow, headline, trailing, body} = props;

  if (!eyebrow && !headline && !trailing && !body) {
    return null;
  }

  return (
    <div className={styles.fastFactStacked}>
      {eyebrow && (
        <p className={css("eyebrow", styles.fastFactStacked__eyebrow)}>
          {eyebrow}
        </p>
      )}

      {headline && (
        <div className={css("stat", styles.fastFactStacked__headline)}>
          {headline}
          {trailing && (
            <span className={styles.fastFactStacked__trailing}>{trailing}</span>
          )}
        </div>
      )}

      {body && <p className={css("p", styles.fastFactStacked__body)}>{body}</p>}
    </div>
  );
};

export default FastFactStacked;
